<template>
  <transition name="slide-fade">
    <div
      v-show="boxData.judgeBox"
      class="uploadFile"
      :style="{
        top: boxData.fix.y + 'px',
        left: boxData.fix.x + 'px',
        'z-index': boxData.Zindex,
      }"
      @mousedown="stopDocument($event)"
      @mouseleave="close()"
    >
      <div class="uploadFile_body">
        <div class="btnbox">
          <label @click="clickLabel" for="imagePicTwo">
            <div class="upload-border" @click="close()">
              <div class="upload-item">
                <i class="iconfont uploadIcon icona-1701"></i>
                图片
              </div>
            </div>
          </label>

          <!--<label @click="clickLabel"  for="imagePic">
          <div class="bg" @click="close()">
            背景图片
          </div>
          </label>-->

          <label @click="clickLabel" for="audio">
            <div class="upload-border" @click="close()">
              <div class="upload-item">
                <i class="iconfont uploadIcon icona-1702"></i>
                录音
              </div>

              <!-- <span class="btnVip">VIP</span> -->
            </div>
          </label>

          <label @click="clickLabel" for="music">
            <div class="upload-border" @click="close()">
              <div class="upload-item">
                <i class="iconfont uploadIcon icona-1703"></i>
                背景音乐
              </div>
            </div>
          </label>

          <label @click="clickLabel" for="gif">
            <div
              class="upload-border"
              @click="
                materialPushAnalysis({ type: 'gifSpritesUpload' });
                close();
              "
            >
              <div class="upload-item">
                <i class="iconfont uploadIcon gifIcon icona-1704"></i>
                GIF图
              </div>
            </div>
          </label>

          <label @click="clickLabel" for="videoMe">
            <el-tooltip class="item" effect="dark" placement="left">
              <div slot="content">
                上传视频，可添加为素材
                <br />或背景，快试试看吧！
              </div>
              <div
                class="upload-border"
                @click="
                  materialPushAnalysis({ type: 'videoClick' });
                  close();
                "
              >
                <div class="upload-item">
                  <i class="iconfont uploadIcon icona-1705"></i>
                  视频
                </div>
                <span class="newVersionIcon" v-if="newVersion">NEW</span>
              </div>
            </el-tooltip>
          </label>

          <label @click="clickLabel" for="spriteJson" v-if="userType">
            <div
              class="upload-border"
              @click="
                materialPushAnalysis({ type: 'videoClick' });
                close();
              "
            >
              <div class="upload-item">
                <i class="iconfont uploadIcon icona-1706"></i>
                lottie
              </div>
              <span class="newVersionIcon" v-if="newVersion">NEW</span>
            </div>
          </label>

          <label @click="clickLabel" for="spriteSvgFrame" v-if="userType">
            <div
              class="upload-border"
              @click="
                materialPushAnalysis({ type: 'videoClick' });
                close();
              "
            >
              <div class="upload-item">
                <i class="iconfont uploadIcon icona-1707"></i>
                SVG相框
              </div>

              <span class="newVersionIcon" v-if="newVersion">NEW</span>
            </div>
          </label>

          <label @click="clickLabel" for="spriteSvgLine" v-if="userType">
            <div
              class="upload-border"
              @click="
                materialPushAnalysis({ type: 'videoClick' });
                close();
              "
            >
              <div class="upload-item">
                <i class="iconfont uploadIcon icona-1708"></i>
                SVG线条
              </div>
              <span class="newVersionIcon" v-if="newVersion">NEW</span>
            </div>
          </label>

          <label @click="clickLabel" for="spriteSvgShap" v-if="userType">
            <div
              class="upload-border"
              @click="
                materialPushAnalysis({ type: 'videoClick' });
                close();
              "
            >
              <div class="upload-item">
                <i class="iconfont uploadIcon icona-1709"></i>
                SVG形状
              </div>

              <span class="newVersionIcon" v-if="newVersion">NEW</span>
            </div>
          </label>

          <div class="tail uploadIcon" style="line-height: 59px">
            上传标准
            <el-tooltip effect="dark" placement="bottom" :open-delay="1000">
              <div slot="content">
                图片：可上传10M以内的PNG/JPG/JPEG,最多可同时上传10张
                <br />
                <br />录音：可上传20M以内的MP3或M4A/wav/aac/amr格式的音乐，
                <br />
                <br />上传后可添加至单个页面。
                <br />
                <br />背景音乐：可上传20M以内的MP3或M4A/wav/aac/amr格式
                <br />
                <br />的音乐，上传后可添加至整个视频。
                <br />
                <br />GIF图：可上传5M以内的GIF图，且文件的后缀必须为“.GIF”。
                <br />
                <br />视频：可添加时长在1-60秒、大小在30M以内的MP4。
                <br />
                <br />
              </div>
              <span class="iconfont icona-17010 uploadIcon"></span>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import Analysis from "../mixins/analysis/materialBu";

export default {
  mixins: [Analysis],
  data() {
    return {
      boxData: {
        judgeBox: false, // 控制盒子开启关闭
        Zindex: 0, // 盒子层级
        data: null, // 盒子数据
        fix: {
          // 弹窗位置
          x: 0,
          y: 0,
        },
      },
      newVersion: false, // 4.7.0版本入场提示
      userType: false,
      cate: "",
    };
  },
  watch: {
    "boxDatas.firstDatas": function (val, oldval) {
      // 判断打开关闭
      let num = Array.indexOf(this.boxDatas.firstDatas, "uploadFile");
      this.boxData.judgeBox = num < 0 ? false : true; // 判断是否打开

      if (this.TOOL && this.boxData.judgeBox) {
        // 打开的操作
        for (let i = 0; i < this.boxDatas.firstDatas.length; i++) {
          if (this.boxDatas.firstDatas[i] !== "uploadFile") {
            this.$bus.emit("FeaturesPop_close_vue", {
              name: this.boxDatas.firstDatas[i],
              type: 1,
            });
          }
        }

        this.boxData.data = this.dataMsg.uploadFile;
        this.boxData.Zindex = (this.dataMsg.length + 1) * 5;
        this.boxData.fix.x = this.boxData.data.posx - 55;
        this.boxData.fix.y = this.boxData.data.posy;
        this.newVersion = this.UserMsg.versionNumber <= 470; // 4.7.0版本入场提示
      }
    },
    "UserMsg.type": function (val, oldval) {
      // UserMsg.type: 0管理员  1普通用户 2外部画师 3来画画师  4.普通管理员(后台管理员中权限最低)
      //               5.合作方管理员，6.会员权限管理员(再普通会员基础上增加会员管理权限),
      //               7:发现广场管理员, 8:学院课程管理员,9:视频学院管理员,10:运营专员
      switch (this.UserMsg.type) {
        case 0:
        case 2:
        case 3:
        case 4:
        case 6:
          this.userType = true;
          break;
      }
    },
  },
  props: ["dataMsg", "boxDatas"],
  computed: {
    ...mapGetters([
      "TOOL",
      "SelectScenes_Msg",
      "TopNav_Size",
      "MaterialPane_Size",
      "S_GlobalSearch",
      "isClipboardEmpty",
      "UserEquity",
      "UserLevel",
      "UserLevelType",
      "UserMsg",
    ]),
    ...mapGetters({
      storeHand: "getHand",
      getResourceTypes: "materialArea/getResourceTypes",
    }),
  },
  mounted() {
    this.$bus.on("upload_vue", this.onUploaded);
  },
  beforeDestroy() {
    this.$bus.off("upload_vue", this.onUploaded);
  },
  methods: {
    ...mapMutations({
      setChoosedResourceType: "materialArea/setChoosedResourceType",
    }),
    ...mapActions({
      addUploadedItem: "resources/addUploadedItem",
    }),
    onUploaded(uploadFileData) {
      // this.addUserItem(uploadFileData);
      let data = {
        url: uploadFileData.data.filename,
        name: uploadFileData.name,
      };
      this.addSprites(data);
    },
    async addUserItem(fileInfo) {
      let { type, data } = fileInfo;
      let cate;
      let query;
      let cbType;
      if (Array.isArray(data) && data.length && type === "image") {
        type = "multiImage";
        cbType = "image";
        query = {
          url: "",
          title: "",
          thumbnailUrl: "",
          fileType: 3,
        };
        data.forEach((v) => {
          query.url += query.url ? "," + v.filename : v.filename;
          query.title += query.title ? "," + v.title : v.title;
          query.thumbnailUrl += query.thumbnailUrl
            ? "," + v.thumbnailName
            : v.thumbnailName;
        });
      }
      if (type === "video") {
        cbType = "video";
        if (fileInfo.name === "videoAndImage") {
          cbType = "videoBg";
        }
        query = {
          url: fileInfo.data.filename,
          title: fileInfo.file.name,
          thumbnailUrl: fileInfo.fileName,
          duration: fileInfo.duration,
          times: fileInfo.duration,
          fileType: 26,
        };
      }
      // record | bgm
      if (type === "audio") {
        cbType = "sound";
        (type = "sound"),
          (cate = fileInfo.name === "music" ? "bgm" : "audioRecord");
        query = {
          duration: fileInfo.duration,
          thumbnailUrl: "",
          times: fileInfo.duration,
          title: fileInfo.file.name,
          url: fileInfo.data.filename,
        };
        if (fileInfo.name === "audio") {
          query.musicType = 1;
        }
      }
      if (type === "image") {
        cbType = "image";
        query = {
          thumbnailUrl: data.thumbnailName,
          title: fileInfo.file.name,
          url: fileInfo.data.filename,
        };
      }
      // open mine content
      this.$store.commit("resources/setIsSearchAll", false);
      let tab = this.getResourceTypes.find((v) => v.key === "mine");
      this.setChoosedResourceType(tab);
      let res = query && (await this.addUploadedItem({ type, ...query }));
      if (res.code === 200) {
        this.$bus.emit("uploadFile.addUserItem", {
          type: cbType,
          cate: this.cate,
          ...res,
        });
      }
    },
    clickLabel(ev) {
      let label = ev.currentTarget.getAttribute("for");
      window.cate = label;
    },
    stopDocument(e) {
      // 防止事件冒泡
      e.stopPropagation();
    },
    close() {
      this.$bus.emit("FeaturesPop_close_vue", {
        name: "uploadFile",
        type: 1,
      });
    },
    addSprites(data) {
      let spriteData = {},
        type = "";
      switch (data.name) {
        case "spriteJson":
          type = "Lottie";
          spriteData = {
            lottieOptions: {
              path: this.$handleAssetsUrl(data.url),
              loop: 4,
              autoplay: true, // 控制播放
            },
            effectCode: "FadeIn",
          };
          break;
        case "spriteSvgFrame":
          type = "Frame";
          spriteData = {
            url: data.url,
          };
          break;
        case "spriteSvgLine":
        case "spriteSvgShap":
          let fileType = data.name == "spriteSvgLine" ? 29 : 28;
          this.TOOL.addSprite(
            "Svg",
            {
              url: data.url,
              fileType: fileType,
              effectCode: "None",
            },
            null,
            true
          ).then((sprite) => {
            sprite
              .updateEffect({
                code: "Hand",
                entranceAnim: {
                  hand: this.storeHand,
                },
              })
              .then(() => {
                this.TOOL.selectSprite([sprite]);
              });
          });
          break;
      }

      if (type) {
        this.TOOL.addSprite(type, spriteData, null, true);
      }
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.uploadFile {
  position: fixed;
  top: 0;
  left: 0;
  width: 262px;
  height: auto;
  box-sizing: border-box;
  box-shadow: 0px 2px 9px rgba(56, 58, 66, 0.1);
  z-index: 35;
  border-radius: 4px;
  overflow: hidden;
  .dragArea {
    background: #d8dee9;
  }

  .uploadFile_body {
    width: 262px;
    height: auto;
    background: #fff;
    position: relative;
    .label {
      position: absolute;
      bottom: 5px;
      right: 5px;
      width: 30px;
      height: 18px;
      background: #d83d60;
      color: #fff;
      border-radius: 5px;
      line-height: 18px;
      text-indent: 0px;
      text-align: center;
    }
    .btnbox {
      padding: 0 19px;
      width: 100%;
      height: auto;
      align-items: center;
      border-radius: 8px;

      .upload-border {
        position: relative;
        width: 100%;
        height: 48px;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 48px;
        letter-spacing: 0px;
        color: #6f6969;
        cursor: pointer;
        border-bottom: 1px solid #d9ddea;
        .upload-item {
          text-align: left;
          margin-left: 70px;
          color: #737596;
        }

        &:hover {
          .upload-item,
          .uploadIcon {
            color: #474261 !important;
          }
        }
        .btnVip {
          position: absolute;
          top: 0;
          bottom: 0px;
          right: -80px;
          left: 0;
          margin: auto;
          width: 30px;
          height: 18px;
          background: #d83d60;
          color: #fff;
          border-radius: 5px;
          line-height: 18px;
          text-indent: 5px;
        }
      }
      .gifIcon {
        font-size: 10px !important;
        transform: scale(0.5) !important;
      }
      .uploadIcon {
        color: #9592a7;
        font-size: 14px;
        margin-right: 8px;
      }
      .img {
        background: url("/static/img/uploadimg01.svg") no-repeat;
        background-size: 18px auto;
        background-position: 5px 15px;

        &:hover {
          background: url("/static/img/uploadimg02.svg") no-repeat;
          background-size: 18px auto;
          background-position: 5px 15px;
          color: #101010;
        }
      }
      .bg {
        background: url("/static/img/uploadbg01.svg") no-repeat;
        background-size: 18px auto;
        background-position: 5px 15px;

        &:hover {
          background: url("/static/img/uploadbg02.svg") no-repeat;
          background-size: 18px auto;
          background-position: 5px 15px;
          color: #101010;
        }
      }
      .music {
        background: url("/static/img/uploadmusic01.svg") no-repeat;
        background-size: 16px auto;
        background-position: 5px 13px;

        &:hover {
          background: url("/static/img/uploadmusic02.svg") no-repeat;
          background-size: 16px auto;
          background-position: 5px 13px;
          color: #101010;
        }
      }
      .sound {
        background: url("/static/img/uploadsound01.svg") no-repeat;
        background-size: 18px auto;
        background-position: 5px 15px;

        &:hover {
          background: url("/static/img/uploadsound02.svg") no-repeat;
          background-size: 18px auto;
          background-position: 5px 15px;
          color: #101010;
        }
      }
      .gif {
        background: url("/static/img/uploadgif01.svg") no-repeat;
        background-size: 20px auto;
        background-position: 5px 22px;

        &:hover {
          background: url("/static/img/uploadgif02.svg") no-repeat;
          background-size: 20px auto;
          background-position: 5px 22px;
          color: #101010;
        }
      }
      .video {
        background: url("/static/img/uploadvideo01.svg") no-repeat;
        background-size: 18px auto;
        background-position: 5px 18px;

        &:hover {
          background: url("/static/img/uploadvideo02.svg") no-repeat;
          background-size: 18px auto;
          background-position: 5px 18px;
          color: #101010;
        }
      }
      .uploadLottie {
        background: url("/static/img/uploadLottie0.svg") no-repeat;
        background-size: 18px auto;
        background-position: 5px 18px;

        &:hover {
          background: url("/static/img/uploadLottie.svg") no-repeat;
          background-size: 18px auto;
          background-position: 5px 18px;
          color: #101010;
        }
      }

      .uploadLine {
        background: url("/static/img/uploadLine0.svg") no-repeat;
        background-size: 18px auto;
        background-position: 5px 18px;

        &:hover {
          background: url("/static/img/uploadLine.svg") no-repeat;
          background-size: 18px auto;
          background-position: 5px 18px;
          color: #101010;
        }
      }

      .uploadProp {
        background: url("/static/img/uploadProp.svg") no-repeat;
        background-size: 18px auto;
        background-position: 5px 18px;

        &:hover {
          background: url("/static/img/uploadProp0.svg") no-repeat;
          background-size: 18px auto;
          background-position: 5px 18px;
          color: #101010;
        }
      }

      .uploadSvg {
        background: url("/static/img/uploadSvg0.svg") no-repeat;
        background-size: 18px auto;
        background-position: 5px 18px;

        &:hover {
          background: url("/static/img/uploadSvg.svg") no-repeat;
          background-size: 18px auto;
          background-position: 5px 18px;
          color: #101010;
        }
      }

      .newVersionIcon {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 32px;
        height: 16px;
        background-color: #ffa200;
        border-radius: 4px;
        font-family: MicrosoftYaHei;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: -0.6px;
        color: #fefeff;
        font-style: initial;
        text-align: center;
        line-height: 16px;
        text-indent: initial;
      }
    }
  }
}

.icon-upload-sound {
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  height: 0px;
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/popups/uploadFile.vue